import React, { useState, useEffect } from "react"
import { CollectionFilterModel } from "@app/scripts/components/collection-filter-model"
import { session } from "@app/scripts/lib/session"
import { search } from "@app/scripts/hooks/icons"
import { isMobile } from "@app/scripts/lib/utils"

type Pagination = {
  totalResults: number
}

type Response = {
  pagination?: Pagination | null
}

export type Props = {
  searchTerm: string
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>
  refine: (field: string, value: string) => void
  response: Response
}

export function SearchBanner({
  searchTerm,
  setSearchTerm,
  refine,
  response,
}: Props) {
  const [isModelView, setIsModelView] = useState(true)

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (searchTerm === "") return
      refine("query", searchTerm)
    }, 700)

    return () => clearTimeout(timeout)
  }, [searchTerm, refine])

  useEffect(() => {
    setIsModelView(session.imageTypeView.value ?? true)
  }, [])

  function handleToggleChange(e: React.ChangeEvent<HTMLInputElement>) {
    setIsModelView(e.target.checked)
  }

  useEffect(() => {
    const skeleton = document.querySelector(
      ".collection-banner--skeleton-container"
    )
    if (skeleton) {
      skeleton.classList.remove("is-visible")
      skeleton.classList.add("is-hidden")
    }
  }, [])

  function handleSearchByEnter(e: React.KeyboardEvent<HTMLInputElement>) {
    if (e.key !== "Enter") return
    e.preventDefault()

    // No redirect read here: the fresh search page load resolves any
    // merchandising redirect for the new term.
    window.location.href = `/search?query=${encodeURIComponent(searchTerm)}`
  }

  const totalResults = response?.pagination?.totalResults ?? 0

  return (
    <div className="ss-search-banner--container">
      <div className="search-banner--text-container">
        <p className="search-banner--title">
          {totalResults === 0
            ? `No results for "${searchTerm}".`
            : `Showing ${totalResults} Search Results`}
        </p>
        {totalResults === 0 && (
          <p className="search-banner--subtitle">
            Try another search or browse our popular collections below.
          </p>
        )}
      </div>

      <div className="search-banner--input-container">
        <input
          className="search-banner--input"
          type="text"
          placeholder="Search"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onKeyUp={handleSearchByEnter}
          aria-label="Search"
        />
        <span className="search-input--icon" aria-hidden="true">
          {search}
        </span>
      </div>

      <div
        className={
          isMobile
            ? "collection-banner--filter-model-container"
            : "search-banner--filter-model-container"
        }
      >
        <CollectionFilterModel
          isModelView={isModelView}
          handleToggleChange={handleToggleChange}
        />
      </div>
    </div>
  )
}
